"use client";

export function AuthShell({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
}) {
  return (
    <div className="auth-shell">
      <div
        style={{
          width: "100%",
          maxWidth: 420,
          background: "var(--panel)",
          border: "1px solid var(--border)",
          borderRadius: 16,
          padding: 28,
          boxShadow: "0 20px 60px rgba(0,0,0,0.4)",
        }}
      >
        <div style={{ fontSize: 13, color: "var(--muted)", marginBottom: 6 }}>
          杨彧鑫
        </div>
        <h1 style={{ margin: "0 0 4px", fontSize: 24 }}>{title}</h1>
        {subtitle && (
          <p style={{ margin: "0 0 18px", color: "var(--muted)", fontSize: 14 }}>
            {subtitle}
          </p>
        )}
        {children}
      </div>
    </div>
  );
}

export const inputStyle: React.CSSProperties = {
  width: "100%",
  padding: "11px 13px",
  borderRadius: 10,
  border: "1px solid var(--border)",
  background: "var(--panel-2)",
  color: "var(--text)",
  fontSize: 16,
  outline: "none",
  marginBottom: 12,
};

export const btnStyle: React.CSSProperties = {
  width: "100%",
  padding: "12px 16px",
  borderRadius: 10,
  border: "none",
  background: "linear-gradient(135deg, var(--accent), var(--accent-2))",
  color: "#fff",
  fontSize: 15,
  fontWeight: 700,
  cursor: "pointer",
};

export const labelStyle: React.CSSProperties = {
  display: "block",
  fontSize: 13,
  color: "var(--muted)",
  marginBottom: 6,
};
